import { useState, useEffect } from 'react';
import { fetchAPI, postAPI } from '../../utils/utils';
import UserInfo from '../login/UserInfo';
import HeaderTabs from '../interface/HeaderTabs';
import Pressable from '../other/Pressable';
import TrashView from './TrashView';

const FOLDER_ICON_OPTIONS = [
    // General
    '📁', '📌', '🔗', '📚', '⭐',
    // Assemblees i reunions
    '🗳️', '📋', '📝', '🎤', '👥', '🏛️',
    // Documents i estatuts
    '📜', '📄', '📑', '⚖️', '📰',
    // Festes i celebracions
    '🎉', '🎊', '🥳', '🎈', '🎵', '💃',
    // Novells i formació
    '🌱', '🎓', '🆕', '👶', '📖',
    // Colònies i activitats
    '🏕️', '⛺', '🏖️', '🌲', '🌄',
    // Menjars i àpats
    '🍽️', '🍕', '🍺', '🥘', '🍷', '☕',
    // Transport
    '🚌', '🚗', '🚐', '🚆', '✈️',
    // Castells
    '🏰', '🗼', '💪', '🤝', '👨‍👩‍👧‍👦',
    // Calendari i temps
    '📅', '🗓️', '⏰', '📆',
    // Diners i finances
    '💰', '💵', '💳', '🏦', '📊',
    // Comunicació
    '📧', '💬', '📢', '📣', '🔔',
    // Salut i seguretat
    '🏥', '⚕️', '🩹', '🆘',
    // Música
    '🎺', '🥁', '🎷', '🎸',
    // Premis
    '🏆', '🥇', '🎖️', '🏅',
    // Canalla
    '👧', '👦', '🎒', '🧒',
    // Fotos i media
    '📷', '📹', '🎥', '🖼️',
    // Altres
    '❤️', '⚙️', '🏠', '🎯', '✅', '🛍️', '🔧', '📍'
];
const DEFAULT_FOLDER_ICON = '📁';

function EnllaçosApp({ userInfo, castellersInfo, ...props }) {
    const [links, setLinks] = useState([]);
    const [editingLink, setEditingLink] = useState(null);
    const [newTitle, setNewTitle] = useState('');
    const [newUrl, setNewUrl] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [folders, setFolders] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState('');
    const [currentFolder, setCurrentFolder] = useState(null);
    const [editingFolder, setEditingFolder] = useState(null);
    const [newFolderName, setNewFolderName] = useState('');
    const [newFolderDescription, setNewFolderDescription] = useState('');
    const [newFolderIcon, setNewFolderIcon] = useState(DEFAULT_FOLDER_ICON);
    const [showIconPicker, setShowIconPicker] = useState(false);
    const [showTrash, setShowTrash] = useState(false);

    const goBackFolder = () => {
        if (currentFolder) {
            const folder = folders.find(f => f.id === currentFolder);
            setCurrentFolder(folder ? folder.parentId || null : null);
        }
    };

    const refreshData = () => {
        fetchAPI('/links', setLinks);
        fetchAPI('/link_folders', setFolders);
    };

    const closeTrash = () => {
        setShowTrash(false);
        refreshData();
    };

    const styles = {
        container: {
            padding: '30px',
            maxWidth: '90%',
            boxSizing: 'border-box',
            margin: '0 auto',
            minHeight: '500px',
        },
        header: {
            marginTop: '30px',
            color: '#333'
        },
        form: {
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            marginBottom: '30px',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
        },
        input: {
            padding: '12px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            fontSize: '16px'
        },
        linkUrl: {
            fontSize: '14px',
            color: '#888',
            marginBottom: '10px'
        },
        textarea: {
            padding: '12px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            fontSize: '16px',
            resize: 'vertical',
            minHeight: '100px'
        },
        buttonGroup: {
            display: 'flex',
            gap: '10px'
        },
        submitButton: {
            padding: '12px 20px',
            backgroundColor: '#28a745',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            flex: 1
        },
        cancelButton: {
            padding: '12px 20px',
            backgroundColor: '#6c757d',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            flex: 1
        },
        linkCard: {
            backgroundColor: '#fff',
            padding: '15px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            marginBottom: '15px',
            transition: 'transform 0.2s'
        },
        linkTitle: {
            fontSize: '20px',
            color: '#007bff',
            textDecoration: 'none',
            marginBottom: '10px'
        },
        linkDescription: {
            fontSize: '16px',
            color: '#555',
            marginBottom: '15px'
        },
        actionButtons: {
            display: 'flex',
            gap: '10px'
        },
        editButton: {
            padding: '8px 16px',
            backgroundColor: '#ffc107',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
        },
        deleteButton: {
            padding: '8px 16px',
            backgroundColor: '#dc3545',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
        },
        moveButton: {
            padding: '6px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            background: '#fff',
            cursor: 'pointer',
            fontSize: '14px',
            color: '#6c757d',
            minWidth: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        folderCard: {
            backgroundColor: '#e8f4f8',
            padding: '15px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            marginBottom: '15px',
            cursor: 'pointer',
            transition: 'transform 0.2s, box-shadow 0.2s',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            border: '1px solid #bee5eb',
            flexWrap: 'wrap'
        },
        folderIcon: {
            fontSize: '24px',
            marginRight: '12px'
        },
        folderName: {
            fontSize: '18px',
            fontWeight: '500',
            color: '#0c5460',
            flex: 1
        },
        folderArrow: {
            fontSize: '20px',
            color: '#0c5460',
            fontWeight: 'bold'
        },
        navigationHeader: {
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            marginBottom: '20px'
        },
        backButton: {
            padding: '8px 16px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            color: '#007bff',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            textDecoration: 'none'
        }
    };

    useEffect(() => {
        fetchAPI('/links', setLinks);
        fetchAPI('/link_folders', setFolders);
    }, []);

    // Socket event listeners for real-time sync
    useEffect(() => {
        if (!props.socket) return;

        const socket = props.socket;

        // Link restored event
        const onLinkRestored = (data) => {
            const { id, link } = data;
            
            // Add to links
            setLinks(prevLinks => [...prevLinks, link]);
        };
        socket.on('.link_restored', onLinkRestored);

        // Folder restored event  
        const onFolderRestored = (data) => {
            const { id, folder, restoredSubfolders, restoredLinks } = data;
            
            // Add restored folder and subfolders
            setFolders(prevFolders => [...prevFolders, folder, ...restoredSubfolders]);
            
            // Add restored links
            setLinks(prevLinks => [...prevLinks, ...restoredLinks]);
        };
        socket.on('.folder_restored', onFolderRestored);

        return () => {
            socket.off('.link_restored', onLinkRestored);
            socket.off('.folder_restored', onFolderRestored);
        };
    }, [props.socket]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const linkData = {
            title: newTitle.trim(),
            url: newUrl.trim(),
            description: newDescription.trim(),
            folderId: selectedFolder || null
        };

        if (editingLink !== null) {
            // Edit existing link
            postAPI('/edit_link', { ...linkData, id: editingLink }, () => {
                setLinks(links.map(link =>
                    link.id === editingLink ? { ...linkData, id: editingLink } : link
                ));
                resetForm();
            });
        } else {
            // Create new link
            postAPI('/add_link', linkData, (response) => {
                setLinks([...links, { ...linkData, id: response.id }]);
                resetForm();
            });
        }
    };

    const handleDelete = (id) => {
        if (window.confirm('Estàs segur que vols eliminar aquest enllaç?')) {
            postAPI('/delete_link', { id }, () => {
                setLinks(links.filter(link => link.id !== id));
            });
        }
    };

    const handleEdit = (link) => {
        setShowForm(true);
        setEditingLink(link.id);
        setNewTitle(link.title);
        setNewUrl(link.url);
        setNewDescription(link.description);
        setSelectedFolder(link.folderId || '');
    };

    const resetForm = () => {
        setEditingLink(null);
        setNewTitle('');
        setNewUrl('');
        setNewDescription('');
        setSelectedFolder(currentFolder || '');
        setShowForm(false);
    };

    const handleAddFolder = () => {
        const name = prompt('Nom de la nova carpeta');
        if (name && name.trim()) {
            const description = prompt('Descripció de la carpeta (opcional)');
            postAPI('/add_link_folder', { 
                name: name.trim(), 
                description: description?.trim() || null,
                parentId: currentFolder || null,
                icon: DEFAULT_FOLDER_ICON
            }, (res) => {
                setFolders([...folders, { 
                    id: res.id, 
                    name: name.trim(), 
                    description: description?.trim() || null,
                    parentId: currentFolder || null,
                    sortOrder: Date.now(),
                    icon: DEFAULT_FOLDER_ICON
                }]);
                setSelectedFolder(res.id);
            });
        }
    };

    const handleEditFolder = (folder) => {
        setEditingFolder(folder.id);
        setNewFolderName(folder.name);
        setNewFolderDescription(folder.description || '');
        setNewFolderIcon(folder.icon || DEFAULT_FOLDER_ICON);
    };

    const handleSaveFolderName = () => {
        if (newFolderName.trim()) {
            postAPI('/edit_link_folder', { 
                id: editingFolder, 
                name: newFolderName.trim(),
                description: newFolderDescription.trim() || null,
                icon: newFolderIcon
            }, () => {
                setFolders(folders.map(f => 
                    f.id === editingFolder ? { 
                        ...f, 
                        name: newFolderName.trim(),
                        description: newFolderDescription.trim() || null,
                        icon: newFolderIcon
                    } : f
                ));
                setEditingFolder(null);
                setNewFolderName('');
                setNewFolderDescription('');
                setNewFolderIcon(DEFAULT_FOLDER_ICON);
                setShowIconPicker(false);
            });
        }
    };

    const handleCancelEditFolder = () => {
        setEditingFolder(null);
        setNewFolderName('');
        setNewFolderDescription('');
        setNewFolderIcon(DEFAULT_FOLDER_ICON);
        setShowIconPicker(false);
    };

    const handleDeleteFolder = (folderId) => {
        postAPI('/delete_link_folder', { id: folderId }, () => {
            fetchAPI('/link_folders', setFolders);
            fetchAPI('/links', setLinks);
            if (currentFolder === folderId) {
                setCurrentFolder(null);
            }
        });
    };

    const handleMoveItem = (item, direction) => {
        const parentId = currentFolder || null;
        postAPI('/reorder_item', { 
            id: item.id, 
            type: item.type, 
            direction, 
            parentId 
        }, () => {
            fetchAPI('/link_folders', setFolders);
            fetchAPI('/links', setLinks);
        });
    };


    const renderForm = (inlineStyle = {}) => (
        <form onSubmit={handleSubmit} style={{...styles.form, ...inlineStyle}}>
            <h3 style={{
                fontSize: '20px',
                marginBottom: '15px',
                color: '#333'
            }}>
                {editingLink !== null ? 'Editar enllaç' : 'Afegir nou enllaç'}
            </h3>
            <input
                type="text"
                placeholder="Títol"
                value={newTitle}
                onChange={(e) => setNewTitle(e.target.value)}
                style={styles.input}
                required
            />
            <input
                type="url"
                placeholder="URL"
                value={newUrl}
                onChange={(e) => setNewUrl(e.target.value)}
                style={styles.input}
                required
            />
            <textarea
                placeholder="Descripció"
                value={newDescription}
                onChange={(e) => setNewDescription(e.target.value)}
                style={styles.textarea}
            />
            <div style={styles.buttonGroup}>
                <button type="submit" style={styles.submitButton}>
                    {editingLink !== null ? 'Desar Canvis' : 'Afegir Enllaç'}
                </button>
                <button 
                    type="button" 
                    onClick={resetForm}
                    style={styles.cancelButton}
                >
                    Cancel·lar
                </button>
            </div>
        </form>
    );


    const getCurrentLinks = () => {
        return currentFolder 
            ? links.filter(l => l.folderId === currentFolder)
            : links.filter(l => !l.folderId);
    };

    const getCurrentFolderName = () => {
        if (!currentFolder) return null;
        const folder = folders.find(f => f.id === currentFolder);
        return folder ? folder.name : null;
    };

    const getFolderIcon = (folder) => folder.icon || DEFAULT_FOLDER_ICON;

    const getCurrentFolders = () => {
        return currentFolder
            ? folders.filter(f => f.parentId === currentFolder)
            : folders.filter(f => !f.parentId);
    };

    const getCombinedItems = () => {
        // Get folders and links for current level
        const currentFolders = getCurrentFolders().map(folder => ({ ...folder, type: 'folder' }));
        const currentLinks = getCurrentLinks().map(link => ({ ...link, type: 'link' }));
        
        // Combine and sort by sortOrder
        return [...currentFolders, ...currentLinks].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
    };

    const renderItem = (item, index, totalItems) => {
        if (item.type === 'folder') {
            return renderFolderCard(item, index, totalItems);
        } else {
            return renderLinkCard(item, index, totalItems);
        }
    };

    const renderFolderCard = (folder, index, totalItems) => {
        
        if (editingFolder === folder.id) {
            return (
                <div key={`folder-${folder.id}`} style={{
                    ...styles.folderCard,
                    cursor: 'default',
                    flexDirection: 'column',
                    alignItems: 'stretch'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', position: 'relative' }}>
                        <div
                            onClick={() => setShowIconPicker(!showIconPicker)}
                            style={{
                                ...styles.folderIcon,
                                cursor: 'pointer',
                                borderRadius: '6px',
                                padding: '4px 8px',
                                transition: 'background-color 0.15s ease',
                                backgroundColor: showIconPicker ? '#e3f2fd' : 'transparent',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px'
                            }}
                            onMouseEnter={(e) => {
                                if (!showIconPicker) e.currentTarget.style.backgroundColor = '#f0f0f0';
                            }}
                            onMouseLeave={(e) => {
                                if (!showIconPicker) e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                        >
                            {newFolderIcon}
                            <span style={{ fontSize: '10px', color: '#999', marginLeft: '2px' }}>▼</span>
                        </div>
                        {showIconPicker ? (
                            <div style={{
                                position: 'absolute',
                                top: '100%',
                                left: '0',
                                marginTop: '4px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '12px',
                                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
                                display: 'grid',
                                gridTemplateColumns: 'repeat(8, 36px)',
                                gap: '2px',
                                padding: '10px',
                                zIndex: 10,
                                maxHeight: '300px',
                                overflowY: 'auto',
                                overflowX: 'hidden'
                            }}>
                                {FOLDER_ICON_OPTIONS.map((iconOption) => (
                                    <div
                                        key={iconOption}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setNewFolderIcon(iconOption);
                                            setShowIconPicker(false);
                                        }}
                                        style={{
                                            width: '36px',
                                            height: '36px',
                                            fontSize: '20px',
                                            cursor: 'pointer',
                                            borderRadius: '6px',
                                            backgroundColor: newFolderIcon === iconOption ? '#e3f2fd' : 'transparent',
                                            border: newFolderIcon === iconOption ? '2px solid #2196f3' : '2px solid transparent',
                                            transition: 'all 0.15s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxSizing: 'border-box'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (newFolderIcon !== iconOption) {
                                                e.currentTarget.style.backgroundColor = '#f5f5f5';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = newFolderIcon === iconOption ? '#e3f2fd' : 'transparent';
                                        }}
                                    >
                                        {iconOption}
                                    </div>
                                ))}
                            </div>
                        ) : null}
                        <input
                            type="text"
                            placeholder="Nom de la carpeta"
                            value={newFolderName}
                            onChange={(e) => setNewFolderName(e.target.value)}
                            style={{
                                flex: 1,
                                padding: '8px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                fontSize: '16px'
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSaveFolderName();
                                if (e.key === 'Escape') handleCancelEditFolder();
                            }}
                            autoFocus
                        />
                    </div>
                    <textarea
                        placeholder="Descripció de la carpeta (opcional)"
                        value={newFolderDescription}
                        onChange={(e) => setNewFolderDescription(e.target.value)}
                        style={{
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            fontSize: '14px',
                            marginBottom: '10px',
                            resize: 'vertical',
                            minHeight: '60px'
                        }}
                    />
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                        <button
                            onClick={handleSaveFolderName}
                            style={{
                                padding: '6px 12px',
                                backgroundColor: '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                        >
                            ✓ Desar
                        </button>
                        <button
                            onClick={handleCancelEditFolder}
                            style={{
                                padding: '6px 12px',
                                backgroundColor: '#6c757d',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                        >
                            ✕ Cancel·lar
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div 
                key={`folder-${folder.id}`} 
                style={styles.folderCard}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                }}
            >
                <div 
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1,
                        cursor: 'pointer'
                    }}
                    onClick={() => setCurrentFolder(folder.id)}
                >
                    <span style={styles.folderIcon}>{getFolderIcon(folder)}</span>
                    <div style={{ flex: 1 }}>
                        <div style={styles.folderName}>{folder.name}</div>
                        {folder.description && (
                            <div style={{
                                fontSize: '14px',
                                color: '#5a6c7d',
                                marginTop: '2px',
                                lineHeight: '1.3'
                            }}>
                                {folder.description}
                            </div>
                        )}
                    </div>
                    <span style={styles.folderArrow}>›</span>
                </div>
                <div style={{
                    display: 'flex',
                    gap: '4px',
                    alignItems: 'center',
                    flexShrink: 0
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2px'
                    }}>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleMoveItem(folder, 'up');
                            }}
                            disabled={index === 0}
                            style={{
                                ...styles.moveButton,
                                opacity: index === 0 ? 0.5 : 1,
                                minWidth: '28px',
                                height: '22px'
                            }}
                        >
                            ↑
                        </button>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleMoveItem(folder, 'down');
                            }}
                            disabled={index === totalItems - 1}
                            style={{
                                ...styles.moveButton,
                                opacity: index === totalItems - 1 ? 0.5 : 1,
                                minWidth: '28px',
                                height: '22px'
                            }}
                        >
                            ↓
                        </button>
                    </div>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEditFolder(folder);
                        }}
                        style={{
                            padding: '4px 8px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            background: '#fff',
                            cursor: 'pointer',
                            fontSize: '13px',
                            color: '#6c757d',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        Editar
                    </button>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteFolder(folder.id);
                        }}
                        style={{
                            padding: '4px 8px',
                            border: '1px solid #dc3545',
                            borderRadius: '4px',
                            background: '#fff',
                            color: '#dc3545',
                            cursor: 'pointer',
                            fontSize: '13px',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        Eliminar
                    </button>
                </div>
            </div>
        );
    };

    const renderLinkCard = (link, index, totalItems) => {
        return (
            editingLink === link.id ? (
                <div key={link.id} style={styles.linkCard}>
                    {renderForm({ marginBottom: '20px' })}
                </div>
            ) : (
                <div key={link.id} style={{
                    ...styles.linkCard,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        flexWrap: 'wrap',
                        gap: '10px'
                    }}>
                        <div style={{flex: 1, minWidth: '150px'}}>
                            <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    ...styles.linkTitle,
                                    display: 'block',
                                    fontWeight: 500,
                                    marginBottom: '4px'
                                }}
                            >
                                {link.title}
                            </a>
                            <p style={{
                                ...styles.linkUrl,
                                margin: 0,
                                fontSize: '13px',
                                color: '#666',
                                maxWidth: '300px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {link.url}
                            </p>
                        </div>
                        <div style={{
                            display: 'flex',
                            gap: '4px',
                            alignItems: 'center',
                            flexShrink: 0
                        }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '2px'
                            }}>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleMoveItem(link, 'up');
                                    }}
                                    disabled={index === 0}
                                    style={{
                                        ...styles.moveButton,
                                        opacity: index === 0 ? 0.5 : 1,
                                        minWidth: '28px',
                                        height: '22px'
                                    }}
                                >
                                    ↑
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleMoveItem(link, 'down');
                                    }}
                                    disabled={index === totalItems - 1}
                                    style={{
                                        ...styles.moveButton,
                                        opacity: index === totalItems - 1 ? 0.5 : 1,
                                        minWidth: '28px',
                                        height: '22px'
                                    }}
                                >
                                    ↓
                                </button>
                            </div>
                            <button
                                onClick={() => handleEdit(link)}
                                style={{
                                    padding: '4px 8px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    background: '#fff',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    color: '#6c757d',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                Editar
                            </button>
                            <button
                                onClick={() => handleDelete(link.id)}
                                style={{
                                    padding: '4px 8px',
                                    border: '1px solid #dc3545',
                                    borderRadius: '4px',
                                    background: '#fff',
                                    color: '#dc3545',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                Eliminar
                            </button>
                        </div>
                    </div>
                    {link.description && (
                        <p style={{
                            ...styles.linkDescription,
                            margin: 0,
                            fontSize: '15px',
                            lineHeight: '1.5',
                            color: '#444'
                        }}>
                            {link.description}
                        </p>
                    )}
                </div>
            )
        );
    };

    return (
        <div style={styles.container}>
            <UserInfo userInfo={userInfo} castellersInfo={castellersInfo} {...props} />
            <HeaderTabs userInfo={userInfo} {...props} />
            <Pressable style={{ backgroundColor: '#eee' }} className="boto-back" href='/'>
                ← Tornar a la pàgina principal
            </Pressable>

            {showTrash ? (
                <TrashView
                    userInfo={userInfo}
                    castellersInfo={castellersInfo}
                    onClose={closeTrash}
                    refreshData={refreshData}
                    hideHeader={true}
                    {...props}
                />
            ) : (
                <>
                    {currentFolder ? (
                        <div style={styles.navigationHeader}>
                            <button
                                onClick={goBackFolder}
                                style={styles.backButton}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            >
                                <span>←</span>
                                Tornar
                            </button>
                            <h2 style={{ ...styles.header, margin: 0 }}>
                                {getCurrentFolderName()}
                            </h2>
                        </div>
                    ) : (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px'
                        }}>
                            <h2 style={{...styles.header, margin: 0}}>
                                Enllaços importants
                            </h2>
                            <button
                                onClick={() => setShowTrash(true)}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#6c757d',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
                            >
                                🗑️ Paperera
                            </button>
                        </div>
                    )}

                    {!editingLink && showForm && renderForm()}

                    {!editingLink && !showForm && (
                        <div style={{
                            display: 'flex',
                            gap: '15px',
                            margin: '20px 0'
                        }}>
                            <button 
                                onClick={() => {
                                    setSelectedFolder(currentFolder || '');
                                    setShowForm(true);
                                }} 
                                style={{
                                    padding: '12px 24px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    transition: 'background-color 0.2s',
                                    flex: 1
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#007bff'}
                            >
                                <span style={{fontSize: '20px'}}>+</span>
                                Afegir nou enllaç
                            </button>
                            
                            <button 
                                onClick={handleAddFolder}
                                style={{
                                    padding: '12px 24px',
                                    backgroundColor: '#28a745',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    transition: 'background-color 0.2s',
                                    flex: 1
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#218838'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#28a745'}
                            >
                                <span style={{fontSize: '20px'}}>{DEFAULT_FOLDER_ICON}</span>
                                {currentFolder ? 'Crea nova subcarpeta' : 'Crea nova carpeta'}
                            </button>
                        </div>
                    )}

                    <div style={{ minHeight: '500px' }}>
                        {(() => {
                            const combinedItems = getCombinedItems();
                            
                            if (combinedItems.length === 0) {
                                return (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '40px',
                                        color: '#6c757d',
                                        fontSize: '16px'
                                    }}>
                                        {currentFolder ? 'Aquesta carpeta està buida.' : 'Encara no hi ha cap enllaç important.'}
                                    </div>
                                );
                            }
                            
                            return combinedItems.map((item, index) => 
                                renderItem(item, index, combinedItems.length)
                            );
                        })()}
                    </div>

                    <div style={{ paddingBottom: '50px' }} />
                </>
            )}
        </div>
    );
}

export default EnllaçosApp;
